<template>
  <div class="bg-color" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="row contact-row" aria-hidden="true">
      <div class="col-sm-3">
        <div class="contact-contain sales-hours">
          <h4 class="contact-header" role="heading" aria-label="2">
            <strong><i class="fa fa-clock-o"></i> Sales Hours</strong>
          </h4>
          <p>
            <strong>Monday - Friday:</strong><br />
            <span class="sales-week-hours">9:00 am - 8:00 pm</span><br />
            <strong>Saturday:</strong><br />
            <span class="sales-sat-hours">9:00 am - 8:00 pm</span><br />
            <strong>Sunday:</strong><br />
            <span class="sales-sun-hours">1:00 pm - 6:00 pm</span>
          </p>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="contact-contain service-hours">
          <h4 class="contact-header" role="heading" aria-label="2">
            <strong><i class="fa fa-clock-o"></i> Service Hours</strong>
          </h4>
          <p>
            <strong>Monday - Friday:</strong><br />
            <span class="service-week-hours">7:30 am - 6:00 pm</span><br />
            <strong>Saturday :</strong><br />
            <span class="service-sat-hours">7:30 am - 5:00 pm</span><br />
            <strong>Sunday:</strong><br />
            <span class="service-sun-hours">Closed</span>
          </p>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="contact-contain phone-numbers">
          <h4 class="contact-header" role="heading" aria-label="2">
            <strong><i class="fa fa-phone"></i> Give Us A Call</strong>
          </h4>
          <p>
            <strong>Sales Department:</strong><br />
            <span class="sales-phone">(555) 555-5555</span>
          </p>
          <p>
            <strong>Service Department:</strong><br />
            <span class="service-phone">(555) 555-5555</span>
          </p>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="contact-contain desk-address">
          <h4 class="contact-header" role="heading" aria-label="2">
            <strong><i class="fa fa-map-marker"></i> Location</strong>
          </h4>
          <p><strong>Dealer Address:</strong></p>
          <a href="#">
            <address class="display-address">
              123 Main Street<br />City, State 12345
            </address>
          </a>
        </div>
      </div>
      <div class="mobile-address">
        <div class="contact-contain">
          <p class="contact-header" role="heading" aria-label="2">
            <strong><i class="fa fa-map-marker"></i> Location</strong>
          </p>
          <p><strong>Dealer Address</strong></p>
          <a class="mobile-address-link track-click">
            <address class="display-address">
              123 Main Street<br />City, State 12345
            </address>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.bg-color {
  background-color: #fff;
}
.contact-row {
  max-width: 1140px;
  margin: auto;
  font-size: 1.4em;
  padding: 20px 0;
}
.contact-row .contact-contain {
  display: table;
  margin: 0 auto;
}
.contact-row .contact-header {
  font-size: 1.2em;
  color: var(--primary-color);
}
.bg-color[data-brand="cjdr"] .contact-row .contact-header {
  color: var(--secondary-color);
}
.contact-row .contact-header {
  margin-top: 20px;
  margin-bottom: 10px;
}

.contact-row .mobile-address {
  display: none;
}
@media (max-width: 767px) {
  .contact-row .mobile-address {
    display: initial;
  }
  .contact-row .desk-address {
    display: none;
  }
}
</style>
